import { lazy } from 'react';

export const SessionList = lazy(() => import('./SessionList'));
